import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"
import { ICancelSubscriptionData } from "../IApisInterface"

export const getUserProfileApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.userProfile)
    return response
}

export const requestDeleteAccountApi = async () => {
    const response = await AxiosInstance.post(apiRoutes?.deleteAccountRequest)
    return response
}

export const confirmDeleteAccountApi = async (payload: { otp: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.deleteAccountConfirm, payload)
    return response
}

export const cancelSubscriptionApi = async (payload: ICancelSubscriptionData) => {
    const response = await AxiosInstance.post(apiRoutes?.cancelSubscription, payload)
    return response
}

export const trackerDashboardApi = async (payload: { page: number, search?: string, limit: number, sort_by?: string, sort_order?: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.trackerDashboard, payload)
    return response
}
export const checkinDashboardApi = async (payload: { page: number, search?: string, limit: number, sort_by?: string, sort_order?: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.checkinDashboard, payload)
    return response
}

export const updateUserProfileApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.updateUserProfile, payload)
    return response
}

export const uploadProfilePictureApi = async (file: any) => {
    const response = await AxiosInstance.post(apiRoutes?.uploadProfilePicture, file,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response;
};

export const getIntercomTokenApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.intercomToken)
    return response
}